export default __webpack_public_path__ + "static/media/locked.240d751c.png";